import { TOPICS } from "@/mocks/contents";

export default function TopicZone() {
  return (
    <section id="topic" className="w-full bg-foreground-950 py-12 md:py-16" aria-label="话题专题">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-bold tracking-[0.2em] text-accent-400">TOPIC · 话题专题</span>
            <h2 className="mt-2 font-heading text-3xl font-black text-background-50 md:text-4xl">
              一个话题，追到底
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-100/70">
              把分散的单篇内容归拢成可连续阅读的专题档案，顺着人物、圈层与现场三条主线，把相关瓜料一网打尽。
            </p>
          </div>
          <a
            href="#gallery"
            className="inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-100/20 bg-background-50/5 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-500 hover:text-foreground-950"
          >
            浏览全部专题档案
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {TOPICS.map((t) => (
            <a
              key={t.title}
              href="#gallery"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl bg-foreground-900 ring-1 ring-foreground-800 transition-colors hover:ring-accent-500"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={t.img}
                  alt={t.title}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900 to-transparent" aria-hidden="true"></div>
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                  {t.label}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-heading text-xl font-bold leading-snug text-background-50">{t.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-background-100/70">{t.summary}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="text-xs text-accent-300">
                    <i className="ri-folder-open-line mr-1 text-sm" aria-hidden="true"></i>
                    {t.count}
                  </span>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-background-50 transition-colors group-hover:text-accent-300">
                    进入专题
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}